<template lang="pug">
div#bin_card_documents
  .bin-card
    .bin-related__title
      div
        span.pr-2 {{ t('components.bin_card.related_documents') }}
    div(v-for='(documents, document_type) in parsedDocuments')
      bin-card-document-list-vue(
        :documents = 'documents',
        :document_type= 'document_type',
        @relatedDocumentData='relatedDocumentData'
        :fullView='fullView'
      )
</template>

<script>
import mixins from "common/mixins"

export default {
  mixins: [mixins.translate],
  name: "bin-card-documents-vue",
  props: {
    related_documents: { type: [Array, Object], default: () => {} },
    fullView: { type: Boolean, default: false }
  },
  data() {
    return {
      parsedDocuments: this.parseRelatedDocuments()
    }
  },
  components: {
    "bin-card-document-list-vue": () => import(
      /* webpackChunkName: "[request]" */ "components/bin_card/BINCardDocumentList"
    )
  },
  methods: {
    relatedDocumentData(id, document_type) {
      if(document_type.includes('legislacion')){
        document_type = 'textolegal';
      }

      this.$emit("relatedDocumentData", id, document_type)
    },
    parseRelatedDocuments() {
      let relatedDocs = this.related_documents
      for (const docType in relatedDocs) {
        relatedDocs[docType] = relatedDocs[docType].filter(doc => doc != null)
      }
      return relatedDocs
    }
  }
}
</script>
